import React from "react";
import { StyledMatchRoundInfo } from "./StyledMatchRoundInfo";
import { useReactAppState } from "../../../shared/containers/utils";
import { slugifyMatch } from "../../../mls-match-list/utils";

const MatchRoundInfo = ({
  competitionPhase = null,
  roundName = null,
  roundGroup = null,
}) => {
  const { t } = useReactAppState();
  const roundInfo = [t(slugifyMatch(competitionPhase)), t(slugifyMatch(roundName)), t(slugifyMatch(roundGroup))];
  const composedInfo = roundInfo.filter((x) => x).join(" • ");

  return (
    <StyledMatchRoundInfo className="mls-c-match-round-info">
      {composedInfo}
    </StyledMatchRoundInfo>
  );
};
export default MatchRoundInfo;
